import { render, staticRenderFns } from "./onebox-previewnewtab.vue?vue&type=template&id=37ff5970&scoped=true&"
import script from "./onebox-previewnewtab.vue?vue&type=script&lang=js&"
export * from "./onebox-previewnewtab.vue?vue&type=script&lang=js&"
import style0 from "./onebox-previewnewtab.vue?vue&type=style&index=0&id=37ff5970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff5970",
  null
  
)

export default component.exports